export const blockIconsSocialGroupNew = (
	<span className='material-symbols-outlined'>group</span>
);
